import angular from 'angular';
import addressComponent from './address.component';
import addressService from './address.service';
import addressConfig from './address.config';

let addressModule = angular.module('app.address',[])
    .component('address', addressComponent)
    .service('addressService', addressService)
    .config(addressConfig);

export default addressModule;



/** WEBPACK FOOTER **
 ** ./www/components/address/address.js
 **/